import React, {Component} from 'react';
import {
    Button,
    Dialog, DialogActions,
    DialogContent, DialogContentText,
    DialogTitle,
    FormControl, FormControlLabel,
    IconButton, InputAdornment,
    Select, Switch,
    Toolbar,
    Typography
} from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import {FilterList, Search} from "@material-ui/icons";
import {withTranslation} from "react-i18next";


const styles = theme => ({
    root: {
        paddingRight: theme.spacing(1),
        backgroundColor: '#d8d8d8'
    },
    filterBar: {
        paddingRight: theme.spacing(1),
        backgroundColor: '#efefef',
    },
    toolbarContainer: {
        width: "100%"
    },
    title: {
        flex: '0 0 auto'
    },
    actions: {
        color: theme.palette.text.secondary
    },
    includeDeletedSwitch: {
        marginRight: theme.spacing(1),
        minWidth: 320,
        textAlign: "right"
    },
    spacer: {
        flex: '1 1 100%'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    searchField: {
        minWidth: 180
    }
});

class PlayersToolbar extends Component {
    state = {
        filterBarOpen: false,
        alertDialogOpen: false,
    };

    handleFilterButton = () => {
        this.setState((state, props) => {
            if (props.searchFieldValue && state.filterBarOpen) {
                return {
                    alertDialogOpen: true
                };
            }
            return {
                filterBarOpen: !state.filterBarOpen
            };
        });
    };

    handleClose = (e, action) => {
        if ('resetAndClose' === action) {
            this.setState((state, props) => {
                return {alertDialogOpen: false, filterBarOpen: false};
            });
            const fakeEvent = {target: {value: ''}};
            this.props.searchChangeHandler(fakeEvent);
        } else if ('close' === action) {
            this.setState({alertDialogOpen: false, filterBarOpen: false});
        } else {
            this.setState({alertDialogOpen: false});
        }
    };

    render() {
        const {
            classes,
            title,
            categories,
            searchChangeHandler,
            includeDeleted,
            includeDeletedChangeHandler,
            t
        } = this.props;

        const items = categories.map((item) => {
            return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
        });
        const {alertDialogOpen} = this.state;

        const filterBar = !this.state.filterBarOpen ? null : (
            <Toolbar className={classes.filterBar}>
                <div className={classes.spacer} />
                <div className={classes.includeDeletedSwitch}>
                    <FormControlLabel
                        value="includeDeleted"
                        label={t("playersEdit.includeDeletedLabel")}
                        labelPlacement="start"
                        control={<Switch checked={includeDeleted}  onChange={includeDeletedChangeHandler} color="primary" />}
                    />
                </div>
                <div className={classes.actions}>
                    <FormControl className={classes.formControl}>
                        <TextField className={classes.searchField} placeholder={t("playersEdit.searchHint")}
                                   onChange={searchChangeHandler}
                                   value={this.props.searchFieldValue}
                                   InputProps={{
                                       endAdornment: (
                                           <InputAdornment position="end">
                                               <IconButton aria-label="player search">
                                                   <Search />
                                               </IconButton>
                                           </InputAdornment>
                                       )
                                   }}
                        >
                        </TextField>
                    </FormControl>
                </div>
            </Toolbar>
        );

        return (
            <div className={classes.toolbarContainer}>
                <Toolbar className={classes.root}>
                    <div className={classes.title}>
                        <Typography color="inherit" variant="h6">
                            {title}
                        </Typography>
                    </div>
                    <div className={classes.spacer} />
                    <div className={classes.actions}>
                        <FormControl className={classes.formControl}>
                            <Select
                                onChange={this.props.handleCategorySelect}
                                inputProps={{
                                    name: 'category',
                                    id: 'category-select'
                                }}
                                value={this.props.selectedCategory}
                            >
                                {items}
                            </Select>
                        </FormControl>
                    </div>
                    <div className={classes.actions}>
                        <IconButton arial-label="filter" onClick={() => this.handleFilterButton()}>
                            <FilterList />
                        </IconButton>
                    </div>
                </Toolbar>
                {filterBar}
                <Dialog open={alertDialogOpen} onClose={(e) => this.handleClose(e, 'close')}>
                    <DialogTitle>Filter active</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            The filter is still active. Do you really want to hide the filter bar now?
                        </DialogContentText>
                        <DialogActions>
                            <Button color="primary" onClick={(e) => this.handleClose(e, 'resetAndClose')}>
                                Reset and Close
                            </Button>
                            <Button color="primary" onClick={(e) => this.handleClose(e, 'close')}>
                                Close
                            </Button>
                            <Button color="primary" autoFocus onClick={(e) => this.handleClose(e, 'leaveOpen')}>
                                Leave Open
                            </Button>
                        </DialogActions>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}


export default withTranslation('messages')(withStyles(styles)(PlayersToolbar));